import React, { useState, useEffect } from 'react';
import { supabaseClient } from '../../services/supabase';

function ReservationToggle() {
  const [enabled, setEnabled] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadSetting();
  }, []);

  const loadSetting = async () => {
    try {
      const { data, error } = await supabaseClient
        .from('store_settings')
        .select('setting_key, setting_value')
        .eq('setting_key', 'reservation_enabled')
        .single();

      if (error && error.code !== 'PGRST116') {
        console.error('予約機能設定読み込みエラー:', error);
        return;
      }

      if (data && data.setting_value !== undefined && data.setting_value !== null) {
        // setting_valueはJSONBなので、様々な形式で返ってくる可能性がある
        const val = data.setting_value;
        if (typeof val === 'boolean') {
          setEnabled(val);
        } else if (typeof val === 'string') {
          setEnabled(val === 'true' || val === '1');
        } else if (typeof val === 'number') {
          setEnabled(val !== 0);
        } else {
          setEnabled(!!val);
        }
      } else {
        setEnabled(true); // デフォルト値
      }
      console.log('予約機能設定読み込み:', data);
    } catch (error) {
      console.error('予約機能設定読み込みエラー:', error);
    }
  };

  const saveSetting = async () => {
    setLoading(true);
    try {
      const { error } = await supabaseClient
        .from('store_settings')
        .upsert(
          {
            setting_key: 'reservation_enabled',
            setting_value: enabled,
          },
          {
            onConflict: 'setting_key',
          }
        );

      if (error) throw error;
      alert(`予約機能を${enabled ? 'ON' : 'OFF'}に設定しました。`);
    } catch (error) {
      console.error('予約機能設定保存エラー:', error);
      alert('予約機能設定の保存に失敗しました。');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="admin-section">
      <div className="container">
        <h2>予約機能ON/OFF</h2>
        <div className="settings-form">
          <h3>予約機能の有効/無効</h3>
          <div className="form-group">
            <label>
              <input
                type="checkbox"
                id="reservationEnabled"
                checked={enabled}
                onChange={(e) => setEnabled(e.target.checked)}
              />
              予約機能を有効にする
            </label>
            <p style={{ color: '#888', marginTop: '10px', fontSize: '0.9rem' }}>
              予約機能をOFFにすると、サイトの「オンライン席予約」セクションが非表示になります。
            </p>
          </div>
          <button
            id="saveReservationToggle"
            className="btn-primary"
            onClick={saveSetting}
            disabled={loading}
          >
            {loading ? '保存中...' : '設定を保存'}
          </button>
        </div>
      </div>
    </section>
  );
}

export default ReservationToggle;

